import { fetchWrapper } from "./restApi";
const API_URL_GET = "https://tvapp.owasoftltd.com/api";

export const getRecipe = (query) => {
  return fetchWrapper("POST", `${API_URL_GET}/RecipeCreate`, {
    serachTerm: query,
  });
};
